import React, { Component } from 'react';
import { ErrorMessage, Form, Formik } from 'formik';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import { dynamicSort } from '../../../../common/utils/api_utils';
import CustomSelectGroup from '../../../../common/formElements/CustomSelectGroup';
import { getSessionOptions, getTemplateCollectionFieldOptions } from './SocketIOTemplateUtils';

export default class SocketIOTemplateForm extends Component {
  createSchemaForFields = () => {
    const { templateId, userIdFields, notificationType, getItemIdFrom } =
      this.props.socketIoTemplateRule;
    return {
      templateId: templateId || '',
      notificationType: notificationType || '',
      userIdFields: userIdFields || '',
      getItemIdFrom: getItemIdFrom || 'collectionUuid',
    };
  };

  getSocketIoTemplateOptions = () => {
    let options = [{ value: '', label: '-Select One-' }];
    let templateOptions = this.props.socketIoTemplates
      .filter((item) => !item.parentTemplateId)
      .sort(dynamicSort('name'))
      .map((item, key) => ({ value: item.uuid, label: item.name }));
    return [...options, ...templateOptions];
  };

  getUserIdFieldsOptions = (templateId) => {
    const { collections, socketIoTemplates, projectDetail } = this.props;
    const selectedTemplate = socketIoTemplates
      ? socketIoTemplates.find((e) => e.uuid === templateId)
      : null;
    const templateCollectionName = selectedTemplate ? selectedTemplate.collectionId : null;
    const templateCollection =
      collections && templateCollectionName
        ? collections.find((e) => e.collectionName === templateCollectionName)
        : null;
    let options = getTemplateCollectionFieldOptions(templateCollection, collections);
    let sessionOptions = getSessionOptions(collections);
    let groupedOptions = [
      {
        label: 'Fields',
        options: options,
      },
      {
        label: 'Current LoggedIn User',
        options: sessionOptions,
      },
    ];
    return groupedOptions;
  };
  itemIdOptions = [
    { value: 'collectionUuid', label: 'Item Id of Collection (Default)' },
    { value: 'previousResponse', label: 'Item Id from Previous Step' },
  ];
  notificationTypeOptions = [
    { value: 'alert', label: 'Window Alert' },
    { value: 'toastSuccess', label: 'Toast Notification - Success' },
    { value: 'toastError', label: 'Toast Notification - Error' },
    { value: 'toastInfo', label: 'Toast Notification - Info' },
    { value: 'toastWarning', label: 'Toast Notification - Warning' },
  ];

  handleSubmit = (values) => {
    this.props.handleSubmit(values);
  };

  closeAllOpenPopup = () => {
    this.props.closeAllOpenPopup();
  };

  render() {
    return (
      <Formik
        enableReinitialize={true}
        initialValues={this.createSchemaForFields()}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          this.handleSubmit(values);
          setSubmitting(false);
          resetForm();
        }}
      >
        {({ isSubmitting, values, setFieldValue, setFieldTouched, errors }) => (
          <Form>
            <div className="row">
              <div className="col-12">
                <div className="form-group">
                  <label>Socket IO Template*</label>
                  <CustomSelect
                    name="templateId"
                    isMulti={false}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={this.getSocketIoTemplateOptions()}
                    value={values['templateId']}
                  />
                  <ErrorMessage name="templateId">
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                  <small>Select a template you want to send via this event.</small>
                </div>
                <div className="form-group">
                  <label>Notification Type*</label>
                  <CustomSelect
                    name="notificationType"
                    isMulti={false}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={this.notificationTypeOptions}
                    value={values['notificationType']}
                  />
                  <ErrorMessage name="notificationType">
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                  <small>Select the notification type.</small>
                </div>
                <div className="form-group">
                  <label>User ID Field*</label>
                  <CustomSelectGroup
                    name="userIdFields"
                    isMulti={true}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={this.getUserIdFieldsOptions(values['templateId'])}
                    value={values['userIdFields']}
                  />
                  <ErrorMessage name="userIdFields">
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                  <small>Select the user ID field to send the socket notification to.</small>
                </div>
                <div className="form-group">
                  <label>Get Item Id From</label>
                  <CustomSelect
                    name="getItemIdFrom"
                    isMulti={false}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={this.itemIdOptions}
                    value={values['getItemIdFrom']}
                  />
                  <ErrorMessage name="getItemIdFrom">
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                  <small>Select the source for the item ID</small>
                </div>
              </div>
            </div>
            {this.props.children}
          </Form>
        )}
      </Formik>
    );
  }
}
